var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 34.95C8.2 34.95 7.5 34.6499 6.9 34.0499C6.3 33.45 6 32.75 6 31.95V3.94995C6 3.14995 6.3 2.44995 6.9 1.84995C7.5 1.24995 8.2 0.949951 9 0.949951H31C31.8 0.949951 32.5 1.24995 33.1 1.84995C33.7 2.44995 34 3.14995 34 3.94995V31.95C34 32.75 33.7 33.45 33.1 34.0499C32.5 34.6499 31.8 34.95 31 34.95H9ZM9 31.95H31V3.94995H9V31.95ZM3 40.95C2.2 40.95 1.5 40.6499 0.9 40.0499C0.3 39.45 0 38.75 0 37.95V7.79995H3V37.95H26.7V40.95H3ZM9 3.94995V31.95V3.94995Z",
    fill: "#767676"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9548f66df11d4bedefa935f35380ebb0.svg";
export { ForwardRef as ReactComponent };